import { Component } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { LoginRequired } from "../../decorators/login.required";
import { PageTitleService } from "../../services/page-title.service";
import { IonicHelper } from "../../helpers/ionic.helper";
import { ApiCollectionResponse, User, ViewDidEnter, ViewDidLeave} from "../../app/app.interfaces";
import { NavController } from "ionic-angular";
import { ApiService } from "../../services/api.service";
import { UserService } from "../../services/user.service";



export interface NotificationConfig {
  deliveryTypes: string[];
  notificationTypes: {};
}

@Component({
  selector: 'notification-settings',
	templateUrl: 'notification-settings.html'
})

@LoginRequired()
export class NotificationSettings implements ViewDidEnter, ViewDidLeave {
  
  loading: boolean = true;
	
  notificationConfig: NotificationConfig = null;
  userNotificationSettings: any = null;
  origUserNotificationSettings: any = null;
  saveTimer: any = null;
  
	constructor(public authService: AuthService,
							private apiService: ApiService,
							private nav: NavController,
							private ionic: IonicHelper,
							private pageTitleService: PageTitleService,
							private userService: UserService) {
	  
	}
  
	
	ionViewDidEnter(): void {
		this.pageTitleService.setPageTitle('notification-settings');
		
		const notificationConfigPromise: Promise<NotificationConfig> = new Promise<NotificationConfig>((resolve) => {
      this.apiService.getCollection('notification_config').then((response: ApiCollectionResponse) => {
        this.notificationConfig = {
          notificationTypes: response.items[0],
          deliveryTypes: response.items[1]
        };
        resolve(this.notificationConfig);
      }).catch((err) => {
				console.error(err);    	
				this.ionic.alert('GLOBAL.GENERAL_ERROR');
			});      
    });
    
		const userNotificationSettingsPromise = new Promise((resolve) => {
		  notificationConfigPromise.then((notificationConfig: NotificationConfig)=> {
		    this.userNotificationSettings = this.authService.user.notificationSettings;
		    
		    const currUserNotificationSettings = this.authService.user.notificationSettings;
		    
		    const userNotificationSettings = {};
		    for(let deliveryType of notificationConfig.deliveryTypes) {
		      let userNotificationSettingsForThisDeliveryType = {};

		      for(let notificationType in notificationConfig.notificationTypes) {		        
		        if(currUserNotificationSettings[deliveryType]!==undefined && currUserNotificationSettings[deliveryType][notificationType]!==undefined){
		          userNotificationSettingsForThisDeliveryType[notificationType] = currUserNotificationSettings[deliveryType][notificationType];
            }
            else {
		          userNotificationSettingsForThisDeliveryType[notificationType] = true;
            }		        
          }          
          userNotificationSettings[deliveryType] = userNotificationSettingsForThisDeliveryType;		      
        }
        
		    this.userNotificationSettings = userNotificationSettings;
		    this.origUserNotificationSettings = JSON.parse(JSON.stringify(userNotificationSettings));// To circumvent passing by reference;

		    resolve();
      });
		    
    });
		
		userNotificationSettingsPromise.then(()=>{
		  this.loading = false;
    });
    
	}

  ionViewDidLeave(): void {
		if(JSON.stringify(this.userNotificationSettings) !== JSON.stringify(this.origUserNotificationSettings)) {
			this.queueSave(0);
		}
  }


	
	getUserNotificationPreference(deliveryType, notificationType){
	  return this.userNotificationSettings[deliveryType][notificationType];
  };

	setUserNotificationPreference(deliveryType, notificationType, enabled){
	  this.userNotificationSettings[deliveryType][notificationType] = enabled;
	  this.queueSave();
  }

  private queueSave(timeout = 2000) {
		if(this.saveTimer) clearTimeout(this.saveTimer);
		this.saveTimer = setTimeout(()=>{
			this.save();
    },timeout);
	}

	save(): void {

	  // this.ionic.toggleLoader(true);
    this.apiService.updateResource(this.authService.user, { notificationSettings: this.userNotificationSettings }).then((updatedUser: User) => {
				this.origUserNotificationSettings = JSON.parse(JSON.stringify(this.userNotificationSettings));
        this.userService.reloadAuthenticatedUser(updatedUser).then(()=> {
						// this.ionic.toggleLoader(false);
            // this.ionic.toast('NOTIFICATIONS.SAVED_TOAST');
				});
    }).catch((err) => {
    	console.error(err);    
	    // this.ionic.toggleLoader(false);
      this.ionic.alert('GLOBAL.GENERAL_ERROR');
		});
  }
	
  
}


// WEBPACK FOOTER //
// ./src/components/notification-settings/notification-settings.ts